function init() {
  document.querySelectorAll('.productImageButton--secondary').forEach(imgButton => {
    imgButton.addEventListener('click', e => {
      setPrimaryProductImage(imgButton.querySelector('img'));
    });
  });
  
  document.querySelectorAll('#product__purchaseVariants').forEach(variantSelector => {
    variantSelector.addEventListener('change', e => {
      updateSelectedVariant(variantSelector);
    });
    
    selectFirstAvailableVariant(variantSelector);
    updateSelectedVariant(variantSelector);
  });
}

function setPrimaryProductImage(srcImage) {
  const primaryImage = document.querySelector('.productImage--primary');
  if (primaryImage.dataset.imageId === srcImage.dataset.imageId) { return; }
  
  const clonedImg = srcImage.cloneNode();
  
  clonedImg.sizes = primaryImage.sizes;
  clonedImg.className = primaryImage.className;
  primaryImage && primaryImage.replaceWith(clonedImg);
  
  const imageId = srcImage.dataset.imageId;
  const activeClass = 'productImageButton--active';
  
  // Set --active class appropriately on secondary image buttons
  const activeQuerySelector = `.productImage--secondary[data-image-id="${ imageId }"]`;
  const inactiveQuerySelector = `.productImage--secondary:not([data-image-id="${ imageId }"])`;

  document.querySelector(activeQuerySelector).closest('button').classList.add(activeClass);
  document.querySelectorAll(inactiveQuerySelector).forEach(img => img.closest('button').classList.remove(activeClass));
  
  
  // Add spinner animation after 200ms
  window.setTimeout(() => {
    clonedImg.addEventListener('load', removeImageLoading, { once: true });
    
    if (!clonedImg.complete) {
      clonedImg.closest('.productImageWrap--primary').classList.add('productImageWrap--loading');
    }
  }, 200);
}

function removeImageLoading() {
  this.closest('.productImageWrap--primary').classList.remove('productImageWrap--loading');
}

function updateSelectedVariant(variantSelector) {
  const selectedOption = variantSelector.selectedOptions[0];
  if (!selectedOption) { return; }
  
  const isAvailable = selectedOption.dataset.available !== 'false';
  const form = variantSelector.closest('.product__purchaseFormWrap');
  
  if (form) {
    form.classList.toggle('product__purchaseFormWrap--outOfStock', !isAvailable);
    
    const spinner = form.querySelector('input[name=quantity]');
    
    if (spinner) {
      (isAvailable) ? spinner.removeAttribute('disabled') : spinner.setAttribute('disabled', 'disabled');
    }
  }
  
  const imageId = selectedOption.dataset.imageId;
  const imageQuerySelector = `.productImage--secondary[data-image-id="${ imageId }"]`;
  const srcImage = document.querySelector(imageQuerySelector);

  if (!srcImage) { return; }
 
  setPrimaryProductImage(srcImage);
}

function selectFirstAvailableVariant(variantSelector) {
  const options = Array.from(variantSelector.options);
  const firstAvailable = options.find(o => o.dataset.available !== 'false');

  if (!firstAvailable) { return; }
  
  variantSelector.value = firstAvailable.value;
}

const imageBinding = { init }
export default imageBinding;